<template>
  <div>
    <el-radio-group v-model="isCollapse" style="margin-bottom: 20px"></el-radio-group>
    <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
      :collapse="isCollapse" background-color="#d80b0b00" text-color="#000000" active-text-color="#ffd04b">
      <!-- <el-menu-item index="0">
        <i class="el-icon-menu" color="#409EFC"></i>
        <template #title>收起</template>
      </el-menu-item> -->
      <el-menu-item index="1">
        <img @click="show()" src="../assets/img/menu_ycjs_hover.png" style="
            width: 23px;
            height: 23px;
            padding-right: 10px;
            padding-bottom: 5px;
          " />
        <!-- <span>远程驾驶</span> -->

        <!-- <el-menu-item-group>
          <template #title>车辆编号</template>
          <el-menu-item
            v-for="(item, index) in car_list"
            :key="index"
            @click="chuan(item)"
            >{{ item.car_number }}
          </el-menu-item>
        </el-menu-item-group>-->
      </el-menu-item>
      <!-- 
      <el-menu-item index="2">
        <i
          ><img
            src="../assets/img/menu_ssjk_hover.png"
            style="
              width: 20px;
              height: 20px;
              padding-right: 10px;
              padding-bottom: 5px;
            "
        /></i>

        <template #title>实时监控</template>
      </el-menu-item>-->
      <!-- <el-menu-item index="3" disabled>
        <i
          ><img
            src="../assets/img/menu_ycjg_hover.png"
            style="
              width: 20px;
              height: 20px;
              padding-right: 10px;
              padding-bottom: 5px;
            "
        /></i>
        <template #title>远程接管</template>
      </el-menu-item>-->
      <!-- <el-menu-item index="4" @click="routerpath('/Bicycle_manage')">
        <i
          ><img
            src="../assets/img/menu_ghlj_hover.png"
            style="
              width: 25px;
              height: 25px;
              padding-right: 10px;
              padding-bottom: 5px;
            "
        /></i>
        <template #title>单车模式</template>
      </el-menu-item>
      <el-menu-item index="5" @click="routerpath('/Four_cars')">
        <i
          ><img
            src="../assets/img/menu_gjdt_hover.png "
            style="
              width: 20px;
              height: 20px;
              padding-right: 10px;
              padding-bottom: 5px;
            "
        /></i>
        <template #title>四车模式</template>
      </el-menu-item>-->
    </el-menu>
  </div>
  <div v-if="display" class="car_list">
    <el-table height="700" :data="
      car_list.filter(
        (data) =>
          !search ||
          data.vin.toLowerCase().includes(search.toLowerCase())
      )
    " @cell-click="handleEdit" style="width: 100%">



      <el-table-column label="车辆编号" width="180" class="yanse">
        <template #header>
          <el-input v-model="search" size="mini" placeholder="请输入车牌号" />
        </template>
        <template #default="scope">

          <p class="re" :class="{ ge: scope.row.status === 1 }"> {{ scope.row.vin }}</p>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { ref, toRefs, reactive } from "vue";
import { get_car_list } from "../api/car_info/api";
import { useRouter } from "vue-router";
let zuzhitime=''
export default {
  name: "ctar",
  setup(props, context) {
    const router = useRouter();
    const handleOpen = (key, keyPath) => {
    };
    const handleClose = (key, keyPath) => {
    };
    const data = reactive({
      isCollapse: true,
      car_list: "",
      car_info: "",
      display: false,
      search: "",
      vin: ''
    });
    //侧边栏展开收缩
    const kai = () => {
      data.isCollapse = !data.isCollapse;
    };
    //获取车辆列表
    const g_car_list = async () => {
      get_car_list(data.vin).then((res) => {
        data.car_list = res.data;
        data.vin = data.car_list[0].vin;
      });
    };
    const routerpath = (path) => {
      router.push({ path: path });
    };
    //显示影藏div
    const show = () => {
      data.display = !data.display;
    };
    //选中车辆  子传父
    const handleEdit = (row, column, cell, event) => {
      data.display = false;
      context.emit("clickFu", row.vin);
    };
    // g_car_list();
    // zuzhitime = setInterval(() => {
   
    //  get_car_list('').then((res) => {
    //     data.car_list = res.data;
    //   });
    // }, 5000)
    return {
      handleOpen,
      handleClose,
      kai,
      show,
      g_car_list,
      handleEdit,
      ...toRefs(data),
      routerpath

    };
  },
};
</script>
<style lang="scss" scoped>
.car_list {
  width: 10%;
  height: 70%;
  margin-top: 2%;
  margin-left: 3.5%;
  position: absolute;
  z-index: 999;
}

.el-menu {
  border: rgb(255, 255, 255);
}

.el-menu-item {
  color: rgb(26, 1, 252);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

//  /deep/ .el-table .cell {
//     color: blue !important;
// }


.re {
  color: rgb(78, 73, 73);
}

.ge {
  color: rgb(1, 162, 255);
}
</style>